import { createSelector } from 'reselect';

export const getNotifications = (state) => state.notificationsData;

export const getAlertSC = createSelector(
  getNotifications,
  (notificationsData) => notificationsData.alert
);
